import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Observable } from "rxjs/Rx";
import { SxHttpService } from "./sxHttp.service";
import { ConfigurationType } from "../model/interfaces/configurationType.interface";

@Injectable()
export class ConfigurationTypeService {
  private configurationTypeService = "api/configurationType";

  constructor(private http: Http, private sxHttp: SxHttpService) {}

  //#region standard persistence
  getAll(): Observable<ConfigurationType[]> {
    return this.sxHttp
      .get(this.configurationTypeService)
      .map((response) => response.json().data as ConfigurationType[]);
  }

  getById(idConfigurationType: string): Observable<ConfigurationType> {
    return this.sxHttp
      .get(this.configurationTypeService + "/" + idConfigurationType)
      .map((response) => response.json().data as ConfigurationType);
  }

  delete(idConfigurationType: string): Promise<Boolean> {
    return this.sxHttp
      .delete(this.configurationTypeService + "/" + idConfigurationType)
      .toPromise()
      .then((result) => result.json().data);
  }

  create(model: ConfigurationType): Promise<any> {
    return this.sxHttp
      .post(this.configurationTypeService, model)
      .toPromise()
      .then((response) => {
        return response.json().data;
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/configurationType.service.ts